import { ProductError, ProductErrorType } from '../../models';

export class TextATrousData {
  sentence: string;
  additionalWrongAnswer?: string[];
  canWriteValue?: boolean;

  constructor(gameData: TextATrousData) {
    if (gameData) {
      this.sentence = gameData.sentence;
      this.additionalWrongAnswer = gameData.additionalWrongAnswer && [...gameData.additionalWrongAnswer];
      this.canWriteValue = gameData.canWriteValue;
    } else {
      this.sentence = '';
      this.canWriteValue = false;
    }
  }

  static validate(gameData: TextATrousData): ProductError[] {
    const errors: ProductError[] = [];
    if (!gameData.sentence) {
      errors.push({ type: ProductErrorType.MISSING, property: 'sentence' });
    }
    if (gameData.additionalWrongAnswer && gameData.additionalWrongAnswer.some(awa => !awa)) {
      errors.push({ type: ProductErrorType.MISSING, property: 'additionalWrongAnswer' });
    }
    return errors;
  }
}
